import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { PermissionSetting, UpdatePermissionSettingsDto } from 'types';

export const updateUserPermissionSettings = ({
  data,
}: {
  data: UpdatePermissionSettingsDto;
  userId: number;
}): Promise<PermissionSetting> => {
  return axios.put(`/api/users/settings`, data);
};

type UseUpdateUserPermissionSettingsOptions = {
  config?: MutationConfig<typeof updateUserPermissionSettings>;
};

export const useUpdateUserPermissionSettings = ({
  config,
}: UseUpdateUserPermissionSettingsOptions = {}) => {
  return useMutation({
    onMutate: async (updatingSettings: any) => {
      await queryClient.cancelQueries(['users', 'permissionSettings']);

      const previousSettings = queryClient.getQueryData<PermissionSetting>([
        'users',
        'permissionSettings',
      ]);

      queryClient.setQueryData(
        ['users', 'permissionSettings'],
        updatingSettings
      );

      return { previousSettings };
    },
    onError: (_, __, context: any) => {
      if (context?.previousSettings) {
        queryClient.setQueryData(
          ['users', 'permissionSettings'],
          context.previousSettings
        );
      }
    },
    onSuccess: (data: PermissionSetting) => {
      queryClient.refetchQueries(['users', 'permissionSettings']);
    },
    ...config,
    mutationFn: updateUserPermissionSettings,
  });
};
